import router from '@/router';
import {LOGIN_ROUTE} from '@/router/routes';
import {removeAccessToken} from '@/utils/access-token';
import {clearUserContext} from '@/utils/logger';
import store from '@/store/index';
import {
  ACTION_CLEAR_ACCOUNT_MODULE,
  ACTION_CLEAR_APPOINTMENTS_MODULE,
  ACTION_CLEAR_BABYBOOK_MODULE,
  ACTION_CLEAR_BILLS_MODULE,
  ACTION_CLEAR_CALLS_MODULE,
  ACTION_CLEAR_MESSAGE_MODULE,
  ACTION_CLEAR_MEDICINE_MODULE,
} from '@/store/types';

export const logout = (sessionError = false) => {
  clearUserContext();
  removeAccessToken();

  store.dispatch(ACTION_CLEAR_ACCOUNT_MODULE);
  store.dispatch(ACTION_CLEAR_APPOINTMENTS_MODULE);
  store.dispatch(ACTION_CLEAR_BABYBOOK_MODULE);
  store.dispatch(ACTION_CLEAR_BILLS_MODULE);
  store.dispatch(ACTION_CLEAR_CALLS_MODULE);
  store.dispatch(ACTION_CLEAR_MESSAGE_MODULE);
  store.dispatch(ACTION_CLEAR_MEDICINE_MODULE);

  router.push({
    name: LOGIN_ROUTE,
    params: {
      // MouseEvent object is passed when logging out on home
      // so strictly check if true is passed
      initialError: sessionError === true ? 'Session expired. Please login again.' : null,
    },
  });
};
